import { Component, EventEmitter, Input, Output } from '@angular/core';

export type ErrorBlockVariant = 'error' | 'warning' | 'info' | 'success';

@Component({
  selector: 'lib-error-block',
  standalone: true,
  template: `
    <section
      class="error-block"
      [class.error-block--error]="variant === 'error'"
      [class.error-block--warning]="variant === 'warning'"
      [class.error-block--info]="variant === 'info'"
      [class.error-block--success]="variant === 'success'"
      [class.error-block--compact]="compact"
    >
      @if (title.trim()) {
        <div class="error-block__title">{{ title }}</div>
      }
      @if (message.trim()) {
        <div class="error-block__message">{{ message }}</div>
      }
      <ng-content />
      @if (actionLabel.trim()) {
        <button
          type="button"
          class="error-block__action"
          (click)="actionClicked.emit()"
        >
          {{ actionLabel }}
        </button>
      }
    </section>
  `,
  styles: [`
    .error-block {
      margin-top: 12px;
      border-radius: 8px;
      border: 1px solid;
      padding: 10px 12px;
      font-size: 14px;
      display: grid;
      gap: 6px;
    }

    .error-block__title {
      font-size: 13px;
      font-weight: 700;
      line-height: 1.3;
    }

    .error-block__message {
      line-height: 1.35;
      word-break: break-word;
    }

    .error-block__action {
      justify-self: start;
      height: 30px;
      border-radius: 6px;
      border: 1px solid currentColor;
      background: transparent;
      color: inherit;
      padding: 0 10px;
      cursor: pointer;
      font-size: 12px;
      font-weight: 600;
    }

    .error-block--compact {
      margin-top: 8px;
      padding: 8px 10px;
      font-size: 13px;
      gap: 4px;
    }

    .error-block--error {
      border-color: #fecaca;
      background: #fef2f2;
      color: #b91c1c;
    }

    .error-block--warning {
      border-color: #fde68a;
      background: #fffbeb;
      color: #b45309;
    }

    .error-block--info {
      border-color: #bfdbfe;
      background: #eff6ff;
      color: #1d4ed8;
    }

    .error-block--success {
      border-color: #bbf7d0;
      background: #f0fdf4;
      color: #166534;
    }
  `],
})
export class ErrorBlockComponent {
  @Input() public variant: ErrorBlockVariant = 'error';
  @Input() public title = '';
  @Input() public message = '';
  @Input() public actionLabel = '';
  @Input() public compact = false;

  @Output() public readonly actionClicked = new EventEmitter<void>();
}
